import { Container } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { cleanMarkup } from "@/functions/cleanMarkup";

export const InsightPageContentSection = ({ className, item }) => {
  const locale = useLocale();

  // Hackfix: customer asked from author section to be h4 styled as h2
  const __html = cleanMarkup(item[`text_${locale}`])
    .replace("<h1>About the author</h1>", '<h5 class="h2">About the author</h5>')
    .replace("<h2>About the author</h2>", '<h5 class="h2">About the author</h5>')
    .replace("<h3>About the author</h3>", '<h5 class="h2">About the author</h5>')
    .replace("<h4>About the author</h4>", '<h5 class="h2">About the author</h5>')
    .replace("<h5>About the author</h5>", '<h5 class="h2">About the author</h5>')
    .replace(
      "marketing@gravitasgroup.com",
      '<a href="mailto:marketing@gravitasgroup.com">marketing@gravitasgroup.com</a>'
    )
    .replace("<h6>About the author</h6>", '<h5 class="h2">About the author</h5>');

  return (
    <div className={clsx(className, "border-bottom py-4 px-0 px-md-4 px-xl-0 py-md-5 mb-4 mb-md-5")}>
      <Container>
        <div className={clsx(classes.content, "")} dangerouslySetInnerHTML={{ __html }} />
      </Container>
    </div>
  );
};
